// extracted by mini-css-extract-plugin
module.exports = {"root":"SectionReviews_root__b3cVO","title":"SectionReviews_title__2rcsD","reviews":"SectionReviews_reviews__25nyl","reviewsLoader":"SectionReviews_reviewsLoader__3hkGU"};